/***
 * @Author: hippo
 * @Date: 2024-01-15 10:54:37
 * @LastEditors: hippo
 * @LastEditTime: 2025-02-04 22:07:21
 * @Description: 
 * @
 */
import React, { forwardRef, Component, useCallback, useState, useEffect, useRef } from 'react'
import classnames from 'classnames'
import _ from 'lodash'
import { useDispatch, useSelector } from 'react-redux';
import { Button, Form, Input, Tooltip } from 'antd'
import { Select as OriginalSelectArea } from '@/components/SelectArea'
import styles from './workers.module.scss'
import FilterItem from '@/components/FilterItem'
import * as apis from '@/apis';
import { getCurrentUser } from '@/models/user/selectors';

const formItemLayout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 16 },
}

const SelectArea = forwardRef((props, ref) => (
  <OriginalSelectArea ref={ref} {...props} />
));

const Filters = React.forwardRef(({ form, query = {}, onChange }, ref) => {
  const { getFieldDecorator } = form;
  const dispatch = useDispatch();
  const user = useSelector(getCurrentUser);
  console.log('query',query)
  const downloadUrl = apis.getWorkersDumpUrl(query);
  console.log('user',user)
  const isShow = user.get('_id').toString() == '5dcf97cc74771b045a32cecc' || user.get('_id').toString() == '5dcf8f0e1ad50e64fc5dae61' ?true:false;
  console.log('isShow',isShow)
  console.log('user._id',user.get('_id'))
  const normalizeTenant = (value, prevValue, allValues) => {
    if (typeof value === 'string') {
      return value
    }
    if (value && value._id) {
      return value._id
    }
    return null
  }

  const handleSubmit = e => {
    e.preventDefault();
    form.validateFields((err, values) => {
      if (err) {
        return console.error(err)
      }

      if (values.time_range && values.time_range[0] && values.time_range[1]) {
        values.time_range = [
          values.time_range[0].startOf('day').valueOf(),
          values.time_range[1].endOf('day').valueOf()
        ]
      }

      values = _.pickBy(values, _.identity)
      onChange(values)
    })
  }

  const handleReset = () => {
    onChange({})
  }

  return (
    <Form onSubmit={handleSubmit} layout="inline">
      <div className={styles.filters}>
        <FilterItem
          className={styles.row}
          label="服务范围">
          {getFieldDecorator('service_area', {
            normalize: normalizeTenant
          })(
            <SelectArea style={{ width: 280 }} />
          )}
        </FilterItem>
        <FilterItem
          className={styles.row}
          label="关键字">
          {getFieldDecorator('keyword')(
            <Input
              style={{ width: 220 }}
              placeholder="请输入姓名/手机号/备注/地址" />
          )}
        </FilterItem>
        <FilterItem
          className={styles.row}>
          <div className={styles.submitBtns}>
            <Button type="primary" htmlType="submit">查询</Button>
            {/* <Button type="default" style={{ marginLeft: 8 }} onClick={handleReset}>重置</Button> */}
          </div>
        </FilterItem>
        {isShow && (
        <FilterItem className={styles.row}>
          <div className={styles.submitBtns}>
            <Tooltip title="注意：将下载当前查询条件内所有数据（无需再次按页下载）">
              <Button type="link" href={downloadUrl}>
                下载
              </Button>
            </Tooltip>
          </div>
        </FilterItem>
        )}
      </div>
    </Form>
  )
})

export default Form.create()(Filters);
